<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <span v-if="bioactiveSelected">
          Nueva preservación {{ bioactiveSelected.nomenclature }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="strainForm" lazy-validation>
            <v-row class="pb-0">
              <v-col class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="validation()"
                  v-model="identification"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              class="py-0"
              v-if="bioactiveSelected && bioactiveSelected.moType === 'fungi'"
            >
              <v-col class="py-0">
                <v-autocomplete
                  outlined
                  label="Selecciona método de preservación"
                  v-model="preservationMethod"
                  :items="methods"
                  return-object
                  item-text="name"
                  clearable
                  dense
                  :rules="validation()"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="py-0">
                <v-text-field
                  outlined
                  label="Cantidad de preservadas"
                  v-model="qtyPreserveds"
                  type="number"
                  clearable
                  dense
                  :rules="validation()"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col class="py-0">
                <v-text-field
                  outlined
                  label="Fecha de preservación"
                  v-model="realDatePreservation"
                  type="date"
                  clearable
                  dense
                  :rules="validation()"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="bioactiveSelected.moType == 'bacteria'">
              <v-col>
                <v-expansion-panels multiple>
                  <v-expansion-panel
                    v-if="
                      bioactiveSelected &&
                      bioactiveSelected.moType == 'bacteria' &&
                      bioactiveSelected.identificationName !==
                        'Streptomyces griseoviridis'
                    "
                  >
                    <v-expansion-panel-header>
                      Pruebas bioquímicas
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-form v-model="valid2" ref="form2" lazy-validation>
                        <v-row>
                          <v-col>
                            <v-checkbox
                              v-model="hasBiochemicalTests"
                              label="Pasa"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row class="my-2">
                          <v-col
                            cols="12"
                            sm="4"
                            v-for="item in bcTestItems"
                            :key="item.text"
                            class="my-0 py-0"
                          >
                            <v-select
                              v-model="form.bcTest[item.value]"
                              :items="bcTestOptions"
                              outlined
                              dense
                              required
                              :label="item.text"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Morfología
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-form v-model="valid" ref="form" lazy-validation>
                        <v-row>
                          <v-col>
                            <v-checkbox
                              v-model="hasColonialMorphology"
                              label="Pasa"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-text-field
                          label="Cepa entificada"
                          dense
                          outlined
                          disabled
                          class="mt-1"
                          v-model="nameIdentification"
                        >
                        </v-text-field>
                        <!-- bacteria -->
                        <v-row
                          v-if="
                            bioactiveSelected &&
                            bioactiveSelected.moType === 'bacteria'
                          "
                        >
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="form.colonyMorphology.shape"
                              :rules="validation('forma', 'F')"
                              :items="shape"
                              outlined
                              dense
                              required
                              label="Forma"
                            ></v-select>
                            <v-select
                              v-model="form.colonyMorphology.margin"
                              :rules="validation('borde')"
                              :items="margin"
                              outlined
                              dense
                              required
                              label="Borde"
                            ></v-select>
                            <v-select
                              v-model="form.colonyMorphology.elevation"
                              :rules="validation('elevación', 'F')"
                              :items="elevation"
                              outlined
                              dense
                              required
                              label="Elevación"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="form.colonyMorphology.surface"
                              :rules="[
                                () => form.colonyMorphology.surface.length > 0,
                              ]"
                              :items="surface"
                              multiple
                              outlined
                              dense
                              required
                              label="Superficie"
                            >
                              <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="mr-2">{{
                                  item.text
                                }}</span>
                                <span
                                  v-if="index === 1"
                                  class="grey--text caption"
                                >
                                  ({{
                                    form.colonyMorphology.surface.length - 1
                                  }}
                                  más)
                                </span>
                              </template>
                            </v-select>
                            <v-select
                              v-model="form.colonyMorphology.opacity"
                              :rules="validation('opacidad', 'F')"
                              :items="opacity"
                              outlined
                              dense
                              required
                              label="Opacidad"
                            ></v-select>
                            <v-select
                              v-model="form.colonyMorphology.color"
                              :rules="validation('color')"
                              :items="color"
                              outlined
                              dense
                              required
                              label="Color"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="form.colonyMorphology.obverse"
                              :rules="validation('color anverso')"
                              :items="fungiColor"
                              outlined
                              dense
                              required
                              label="Color anverso"
                            ></v-select>
                            <v-select
                              v-model="form.colonyMorphology.reverse"
                              :rules="validation('color reverso')"
                              :items="fungiColor"
                              outlined
                              dense
                              required
                              label="Color reverso"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select
                              v-model="form.colonyMorphology.texture"
                              :rules="validation('textura', 'F')"
                              :items="fungiTexture"
                              outlined
                              dense
                              required
                              label="Textura"
                            ></v-select>
                            <v-select
                              v-model="form.colonyMorphology.growth"
                              :rules="validation('crecimiento')"
                              :items="growth"
                              outlined
                              dense
                              required
                              label="Crecimiento"
                            ></v-select>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Observaciones
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-textarea
                            outlined
                            name="input-7-4"
                            label="Observaciones"
                            v-model="observations"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Evidencia fotografica
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-form ref="formEvidence" lazy-validation>
                        <v-row align="center">
                          <v-col>
                            <v-file-input
                              v-model="files"
                              counter
                              multiple
                              show-size
                              :rules="validation('Imagen de cepa')"
                              accept="image/png, image/jpeg, image/bmp"
                              truncate-length="50"
                              label="Cargar imagen de cepa"
                              prepend-icon="mdi-file"
                            >
                              <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </v-col>
                          <v-col>
                            <v-btn
                              small
                              rounded
                              color="primary"
                              @click="addEvidence"
                              :loading="uploadingEvidence"
                            >
                              <v-icon> mdi-paperclip </v-icon>
                              Añadir evidencia
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                      <v-carousel v-if="imgs.length != 0">
                        <v-carousel-item v-for="(item, i) in imgs" :key="i">
                          <v-img
                            alt="Imagen altamente responsiva"
                            :src="item"
                            sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, (max-width: 640px) 600px, (max-width: 800px) 760px, 1200px"
                          ></v-img>
                        </v-carousel-item>
                      </v-carousel>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="addPreservedMethod"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//qr library
import qrcode from "qrcode-generator";
export default {
  data: () => ({
    loader: false,
    identification: null,
    isLoading: false,
    packagingType: null,
    preservationMethod: null,
    qtyPreserveds: null,
    methods: [
      { name: "Tubo inclinado", value: "INCLINED TUBE" },
      { name: "Discos de agr", value: "AGAR DISCS" },
    ],
    hasBiochemicalTests: false,
    hasColonialMorphology: false,
    nameIdentification: "",
    observations: "",
    loading: false,
    form: {
      colonyMorphology: {
        shape: "",
        margin: "",
        elevation: "",
        surface: [],
        color: "",
        opacity: "",
        obverse: "",
        reverse: "",
        texture: "",
        growth: "",
      },
      bcTest: {
        gram: null,
        KOH: null,
        catalase: null,
        oxidase: null,
        simmonsCitrate: null,
        MIO: null,
        LIA: null,
        TSI: null,
        christensenUrea: null,
      },
    },
    valid: true,
    valid2: true,
    bcTestItems: [
      { text: "Gram", value: "gram" },
      { text: "KOH", value: "KOH" },
      { text: "Oxidasa", value: "oxidase" },
    ],
    bcTestOptions: [
      { text: "Negativo", value: false },
      { text: "Positivo", value: true },
    ],
    // user info
    user: JSON.parse(localStorage.getItem("user")),
    files: [],
    imgs: [],
    uploadingEvidence: false,
    realDatePreservation: null,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("bioactives", ["bioactiveSelected"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    if (this.bioactiveSelected) {
      this.identification = this.bioactiveSelected.identificationName;
      if (this.bioactiveSelected.moType == "bacteria") {
        await this.fecthMorphology();
      }
    }
  },
  methods: {
    ...mapActions("bioactives", [
      "searchBioactives",
      "addPreserved",
      "getMorphology",
      "uploadStrainPhoto",
      "updateEvidenceReactivation",
    ]),
    ...mapMutations("bioactives", [
      "SET_FETCH_BIO_LIST",
      "SET_FETCH_PRESERVED_LIST",
    ]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),

    async addPreservedMethod() {
      if (this.$refs.strainForm.validate()) {
        //make strain request to cepario production
        try {
          this.isLoading = true;
          let payload = {};
          if (this.bioactiveSelected.moType === "fungi") {
            payload = {
              identification: this.bioactiveSelected._id,
              packagingType: "TUBE",
              preservationMethod: this.preservationMethod.value,
              qtyPreserveds: this.qtyPreserveds,
            };
          } else {
            payload = {
              identification: this.bioactiveSelected._id,
              packagingType: "TUBE",
              qtyPreserveds: this.qtyPreserveds,
            };
          }

          payload.realDatePreservation = this.realDatePreservation;
          if (this.bioactiveSelected.moType == "bacteria") {
            payload.colonyMorphology = this.form.colonyMorphology;
            payload.bcTest = this.form.bcTest;
            payload.hasBiochemicalTests = this.hasBiochemicalTests;
            payload.hasColonialMorphology = this.hasColonialMorphology;
            payload.observations = this.observations;
            payload.imgs = this.imgs;
          }
          let response = await this.addPreserved(payload);
          if (response) {
            if (!response.error) {
              this.identification = null;
              this.preservationMethod = null;
              this.$swal({
                icon: "success",
                title: `Preservada creada con exito !! `,
                showConfirmButton: false,
                timer: 2000,
              });

              //reload all tables
              this.SET_FETCH_BIO_LIST(true);
              this.SET_FETCH_PRESERVED_LIST(true);
              //close modal
              this.show = false;
            } else {
              this.showErrotMessage();
            }
          } else {
            this.showErrotMessage();
          }
        } catch (e) {
          console.log(e);
          this.showErrotMessage();
        }
        this.isLoading = false;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    showErrotMessage() {
      this.$swal({
        icon: "error",
        title: `Algo salio mal al crear preservada`,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    closeModal() {
      this.show = false;
      this.identification = null;
      this.preservationMethod = null;
    },
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    async fecthMorphology() {
      try {
        let response = await this.getMorphology({
          identification: this.bioactiveSelected.identification,
        });
        if (response) {
          if (!response.error) {
            let mophologyFound = response.mophologyFound;
            if (mophologyFound) {
              if (this.bioactiveSelected.moType == "bacteria") {
                this.form.colonyMorphology.shape = mophologyFound.shape
                  ? mophologyFound.shape
                  : "";
                this.form.colonyMorphology.margin = mophologyFound.margin
                  ? mophologyFound.margin
                  : "";
                this.form.colonyMorphology.elevation = mophologyFound.elevation
                  ? mophologyFound.elevation
                  : "";
                this.form.colonyMorphology.surface = mophologyFound.surface
                  ? mophologyFound.surface
                  : "";
                this.form.colonyMorphology.opacity = mophologyFound.opacity
                  ? mophologyFound.opacity
                  : "";
                this.form.colonyMorphology.color = mophologyFound.color
                  ? mophologyFound.color
                  : "";
              } else {
                this.form.colonyMorphology.obverse = mophologyFound.obverse
                  ? mophologyFound.obverse
                  : "";
                this.form.colonyMorphology.reverse = mophologyFound.reverse
                  ? mophologyFound.reverse
                  : "";
                this.form.colonyMorphology.texture = mophologyFound.texture
                  ? mophologyFound.texture
                  : "";
                this.form.colonyMorphology.growth = mophologyFound.growth
                  ? mophologyFound.growth
                  : "";
              }
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar morfología`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar morfología`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar morfología`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async addEvidence() {
      if (this.$refs.formEvidence.validate()) {
        try {
          this.uploadingEvidence = true;
          let files = [];
          for (let item of this.files) {
            let fileB64 = await this.getBase64(item);
            files.push(fileB64);
          }
          for (let file of files) {
            let imgFile = this.dataURLtoFile(file);
            let form_data = new FormData();
            form_data.append("file", imgFile);
            const { urlImg } = await this.uploadStrainPhoto(form_data);
            this.imgs.push(urlImg);
          }
          this.files = [];
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al subir evidencia `,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.uploadingEvidence = false;
      }
    },
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    dataURLtoFile(img) {
      let arr = img.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      // let newDate = this.getDatewithTime();
      return new File([u8arr], `delivery.png`, { type: mime });
    },
  },
  watch: {
    async search(val) {
      if (!val) return;
      else {
        this.loader = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());

        try {
          const response = await this.searchBioactives({
            name: val,
          });
          if (response.error) throw response;

          this.identificationsFounded = response.strains;
        } catch (e) {
          console.log(e);
        }
        this.loader = false;
      }
    },
  },
  beforeUpdate() {
    // if (this.bioactiveSelected)
    //   this.search = this.bioactiveSelected.identificationName;
    if (this.bioactiveSelected)
      this.identification = this.bioactiveSelected.identificationName;
  },
  destroyed() {
    this.identification = null;
    this.search = null;
    this.identificationsFounded = [];
    this.preservationMethod = null;
  },
};
</script>
